module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Tell Me What to Eat If I Have Celiac Disease")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_c('em', [_vm._v("Nutrition You Can Live With")])]), _vm._v(" "), _c('p', {
    staticClass: "authortitle"
  }, [_vm._v("By Kimberly A. Tessmer, RD, LD"), _c('br'), _vm._v("Foreword by Elaine Magee")]), _vm._v(" "), _c('p', {
    staticClass: "images1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566c7861","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0